import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="one-trust"
export default class extends Controller {
  connect() {
    const dataDomain = this.element.dataset.domainScript;
    if (!dataDomain) return;

    // Dynamically inject the OneTrust script
    if (!document.querySelector('script[data-domain-script="' + dataDomain + '"]')) {
      const script = document.createElement("script");
      script.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
      script.type = "text/javascript";
      script.charset = "UTF-8";
      script.setAttribute("data-domain-script", dataDomain);
      document.head.appendChild(script);
    }

    // Define OptanonWrapper if not already defined
    if (typeof window.OptanonWrapper !== "function") {
      window.OptanonWrapper = function() {};
    }
  }
}